if (!customElements.get('delivery-estimation')) {
  class deliveryEstimation extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('.est-form');
      this.submitBtn = this.querySelector('[data-check-eta]');
      this.postalCode = this.form.querySelector('[name="postal_code"]');
      this.varId = this.form.querySelector('[name="variant_id"]');
      this.localStorageData = this.getCookie('shiprocketEta');
      this.estMsg = this.querySelector('.est-msg');

      this.init();
    }


    onImputCheck = () => {
      this.input = this.form.querySelector('.input_text');
      this.submit = this.form.querySelector('.submit');
      this.input.addEventListener('input',()=>
      {
        if (this.input.value.length == 6) {
          this.submitBtn.click();
        }
      })
    }
    
    onClick = () => {
      this.submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.postalCode.value != '' && this.postalCode.value.length == 6) {
          // gtag("event", "pincode_eta_check", {
          //   postal_code: this.postalCode.value,
          //   page_location: window.location.href
          // });

          if (this.localStorageData) {
            let zipData = JSON.parse(this.localStorageData);
            let varID = parseInt(this.varId.value);
            let data = zipData[varID];
            if (data && data.postal_code == this.postalCode.value) {
              this.renderPreData();
            } else {
              this.fetchData();
            }
          } else {
            this.fetchData();
          }
        } else {
          let html = `<div class="eta-msg-wrapper">
                        <span class="error-msg">Pincode not valid. Try another one.</span>
                      </div>`;
          this.estMsg.innerHTML = html;
          this.form.classList.add('has-error');
          this.form.classList.remove('has-success');
        }
      }) 
    }
    onchange = () => {
      this.postalCode.addEventListener('input', () => {
          this.form.classList.remove('has-error');
          this.form.classList.remove('has-success');
          this.estMsg.innerHTML = '';
      })
    }

    fetchData = () => {
      let postalCode = this.form.querySelector('[name="postal_code"]')?.value;
      let varId = this.form.querySelector('[name="variant_id"]')?.value;
      this.form.classList.add('loading');
      fetch('https://cpanel.mensabrands.com/ShiprocketETAWidget/public/zipcodeHS', {
        method: 'POST',
        headers: {"Content-Type": "application/json",},
        body: JSON.stringify({postal_code:postalCode,variant_id: varId})
      })
      .then(res => res.json())
      .then(res => {
        this.form.classList.remove('loading');
        this.renderData(res);
      })
    }

    renderData = ($data) => {
      let data = $data;
      if (data.status == '404') {
        let html = `<div class="eta-msg-wrapper">
                        <span class="error-msg">Oops, it looks like we don't ship to your Pincode Try another one.</span>
                      </div>`;
          this.estMsg.innerHTML = html;
          this.form.classList.add('has-error');
          this.form.classList.remove('has-success');
      } else {
        let etd = data.data.available_courier_companies[0].etd;
        let estimated_delivery_days = data.data.available_courier_companies[0].estimated_delivery_days;
  
        let postalCode = this.form.querySelector('[name="postal_code"]')?.value;
        let varId = this.form.querySelector('[name="variant_id"]')?.value;
  
        let storageData = {}; 
        storageData[varId] = {
          postal_code:postalCode,var_id:varId,etd:etd,estimated_delivery_days:estimated_delivery_days
        }
        this.setLocalStorage(storageData,varId);
      }
    }

    setLocalStorage = ($data,$varID) => {
      let shirocketData = this.getCookie('shiprocketEta');
      let varID = parseInt($varID);
      document.cookie = "shiprocketEta=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      if (shirocketData) {
        shirocketData = JSON.parse(shirocketData);
        shirocketData[varID] = $data[$varID];
        this.setCookie('shiprocketEta',JSON.stringify(shirocketData),1);
      } else {
        this.setCookie('shiprocketEta',JSON.stringify($data),1);
      }
      this.localStorageData = this.getCookie('shiprocketEta')
      this.renderPreData();
    }

    renderPreData = () => {
      if (this.localStorageData) {
        let zipData = JSON.parse(this.localStorageData);
        let values = Object.values(zipData);
        let data = values[values.length - 1];

    let estTime = this.getRemainingHours();
    if (data) {
      let durationTime = new Date();
      let etaDate = new Date(data.etd);
      if (durationTime.getHours() >= 12 && (durationTime.getHours() < 24)) {
        etaDate.setDate(etaDate.getDate() + 1);
      } else {
        etaDate.setDate(etaDate.getDate());
      }
      let options = { weekday: 'long', day: 'numeric', month: 'long' };
      etaDate = etaDate.toLocaleDateString('en-IN', options);

      let dataCode = data.postal_code;
      let postal_code = document.querySelectorAll('delivery-estimation #postal_code');
      postal_code.forEach((postalCode) => {
        postalCode.value = dataCode
      })
      // this.postalCode.value = data.postal_code;

      let currentTime = new Date();
      let currentTimeHour = currentTime.getHours();
      let currentTimeMinutes = currentTime.getMinutes();

      let html = `<div class="eta-msg-wrapper">
                    <span class="success-msg">Estimated Delivery By <strong>${etaDate}</strong></span>
                    ${((currentTimeHour === 9 && currentTimeMinutes >= 0) || (currentTimeHour > 9 && currentTimeHour < 11) || (currentTimeHour === 11 && currentTimeMinutes <= 59)) ? `<span class="est-time">Order within ${estTime}</span>` : ''}
                  </div>`;
      let estMesg = document.querySelectorAll('delivery-estimation .est-msg');
      estMesg.forEach((message) => {
        message.innerHTML = html;
      })
      let allForm = document.querySelectorAll('.est-form');
      allForm.forEach((form) => {
        form.classList.remove('has-error');
        form.classList.add('has-success');
      })
    }
  }
}

    getRemainingHours = () => {
        const now = new Date();
        const targetTimeToday = new Date(now);
        targetTimeToday.setHours(12);
        targetTimeToday.setMinutes(0);
        targetTimeToday.setSeconds(0);
        targetTimeToday.setMilliseconds(0);
      
        let isAfterFourThirty = now.getTime() > targetTimeToday.getTime();
        let targetTime = isAfterFourThirty ? new Date(targetTimeToday.getTime() + 24 * 60 * 60 * 1000) : targetTimeToday;
        let timeDifference = targetTime - now;
        let remainingHours = Math.floor(timeDifference / (1000 * 60 * 60));
        let remainingMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        // let remainingSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        let remainingTime = `${remainingHours} Hrs ${remainingMinutes} Mins`;
      return remainingTime;
    }

    setCookie = (cname, cvalue, exdays) => {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie = (cname) => {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    init = () => {
      this.renderPreData();
      this.onchange();
      this.onClick(); 
      this.onImputCheck();
    }

  }
  customElements.define('delivery-estimation',deliveryEstimation)
}
